<template>
  <form class="creativeUnitForm" id="creativeUnitForm" :action="isExport ? action : ''" :method="isExport ? 'post' : ''" @submit.prevent="onSubmit">
    <div v-if="isExport">
      <input name="action" class="hidden" :value="actions.value">
      <input name="ids" class="hidden" :value="selectedUnits.ids.toString()">
    </div>
    <dropdown class="creativeUnitForm__dropdown" :options="actions.options[type]" v-model="actions.value"
              current="action"/>
    <button-cta class="creativeUnitForm__submit" :type="isExport ? 'submit' : ''" :data-action="actions.value" :onClick="updateAction">Go</button-cta>
  </form>
</template>

<script>
import Dropdown from '@/components/Form/Dropdown/dropdown'
import ButtonCta from '@/components/Button/button'

const commonActions = [
  {
    name: 'Action',
    value: 'action'
  },
  {
    name: 'Render',
    value: 'render'
  },
  {
    name: 'Download',
    value: 'export-service'
  },
  {
    name: 'Create Ad Tag Group',
    value: 'create-ad-tag-group'
  },
  {
    name: 'Share',
    value: 'send-to-link'
  },
  {
    name: 'Edit',
    value: 'edit'
  },
  {
    name: 'Delete',
    value: 'delete'
  }
]

export default {
  name: 'CreativeUnitForm',
  components: {
    Dropdown,
    ButtonCta
  },
  props: {
    action: String,
    type: String,
    selectedUnits: Object
  },
  mounted () {},
  data: () => ({
    actions: {
      value: '',
      options: {
        html: [
          ...commonActions
        ],
        psd: [
          ...commonActions,
          {
            name: 'Send to Creative',
            value: 'send-to-creative'
          }
        ],
        'html-video': [
          ...commonActions
        ]
      }
    }
  }),
  computed: {
    isPostAction () {
      return this.actions.value.indexOf('export-service') !== -1 || this.actions.value === 'create-ad-tag-group'
    },
    isExport () {
      return this.actions.value.indexOf('export-service') !== -1
    },
    isSendToCreative () {
      return this.actions.value === 'send-to-creative'
    },
    isAdTagCreation () {
      return this.actions.value === 'create-ad-tag-group'
    },
    isRenderUnitForHtmlToVideo () {
      return this.actions.value === 'render' && this.type === 'html-video'
    },
    isEdit () {
      return this.actions.value === 'edit'
    },
    isShare () {
      return this.actions.value === 'send-to-link'
    }
  },
  methods: {
    updateAction (e) {
      // don't call JSON api if export
      if (this.isExport || this.isSendToCreative || this.isAdTagCreation || this.isEdit || this.isShare) {
        return
      }
      this.$emit('actionChange', e)
    },
    onSubmit () {
      // if (this.type === 'html-video' && this.isRenderUnitForHtmlToVideo) {
      //   this.$emit('renderHtmlToVideoOptionsModal')
      // }

      if (this.isShare) {
        this.$emit('launchShareCreateLinkModal')
      }

      if (this.isExport) {
        this.$emit('launchChargeModal')
      }
      // check to see if its a send to tag group action
      if (this.isAdTagCreation) {
        this.$emit('launchAdTagModal')
      }
      if (this.isSendToCreative) {
        console.log('Verifying choices before launching modal')
        this.$emit('launchSendToCreativeModal')
      }
      if (this.isEdit) {
        this.$emit('launchBulkEditModal')
      }
    }
  }
}
</script>

<style lang="scss">
  .creativeUnitForm {
    max-width: 200px;
    align-items: center;
    margin-bottom: 15px;
    display: flex;
    &__dropdown {
      width: 145px;
    }
    &__submit {
      margin-left: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CreativeUnitForm/creative-unit-form.vue